<template>
    <div>
        <div class="section-heading">
            <h4>Products</h4>
            <p>Add your product details</p>
            <p class="w-50 mt-3">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident porro eligendi modi
                esse nobis id voluptates, laudantium, quibusdam quos exercitationem consectetur nemo. Quo aliquid,
                error iusto nam facilis delectus reprehenderit cupiditate repudiandae, aut et sapiente praesentium
                earum aliquam optio ex ullam impedit consectetur facere sunt quasi. Dolores sit minima error natus
                cumque illo facilis, aliquid, praesentium id odit doloremque aspernatur quasi ea non nisi, itaque
                quaerat nostrum laborum tenetur ut dolor perspiciatis tempore! Architecto, eveniet ipsam a velit
                rerum labore nihil omnis mollitia suscipit distinctio ipsa odio corrupti molestiae odit ab nulla
                minus repudiandae pariatur fugit quis. Tempore, odit soluta accusamus ipsam, tempora, repellat omnis
                accusantium.</p>
        </div>
        <div class="mt-4">
            <p class="font-weight-bold">Platforms Selected</p>
            <div class="d-flex w-50 flex-wrap" v-if="selectedPlatforms.length">
                <button class="demo-btn active" v-for="platform of selectedPlatforms" :key="platform.platform_id">
                    {{ platform.platform_name }}
                </button>
            </div>
            <p v-else style="color: var(--red); font-size: 12px; font-weight: 400;">Please select platform(s) to
                continue</p>
        </div>
        <!-- Table for uploading products -->
        <div v-if="selectedPlatforms.length" class="section-heading mt-4" style="max-width: 920px;">
            <div class="d-flex align-items-center justify-content-between">
                <p class="mr-4">Download template and upload as per platform.</p>
                <button class="demo-btn active px-3 px-2" title="Download Template"
                    style="border-radius: 5px !important; background-color: var(--primary_brand); color: white;"
                    @click="downloadProductTemplate">
                    <span class="mr-2">Download Template</span>
                    <img src="../../../../../public/Icons_SVG/DownloadIcon.svg" width="18" alt="download-template">
                </button>
            </div>
            <table class="demo-table">
                <thead>
                    <tr>
                        <th>Platforms</th>
                        <th>Upload Products</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row of selectedPlatforms" :key="row.platform_id">
                        <td class="text-left pl-4">
                            <img :src="require(`../../../../../public/img/${row.slug}.png`)" width="17"
                                :alt="row.platform_name + ' logo'">
                            <span class="ml-3" style="font-size: 14px;">{{ row.platform_name }}</span>
                        </td>
                        <td class="py-3">
                            <input type="file" class="d-none" accept=".xlsx" :id="row.platform_id + '_file'"
                                @change="uploadProductTemplate(row, $event)">
                            <label :for="row.platform_id + '_file'">
                                <div class="demo-btn active px-4 py-2 mr-0 mb-0"
                                    style="border-radius: 5px !important; cursor: pointer;">
                                    Upload
                                </div>
                            </label>
                            <div v-if="!uploadedProducts[row.platform_id] && invalidCheck"
                                style="color: var(--red); font-size: 13px;">Please upload the products.</div>
                            <div v-else-if="uploadedProducts[row.platform_id]" style="color: green; font-size: 13px;">
                                {{ uploadedProducts[row.platform_id].name }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-4">
            <div class="d-flex">
                <button class="primarycolor mr-3" @click="saveUploadedProducts">Save and Next</button>
                <button class="navigationButton" @click="setSelectedSection(previousSection)">Back</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: "Products",
    data() {
        return {
            uploadedProducts: {},
            invalidCheck: false,
            currentSectionIndex: null,
            nextSection: null,
            previousSection: null
        }
    },
    computed: {
        ...mapState("DemoStore", ['selectedFeatures','selectedPlatforms', 'sections', 'selectedSection'])
    },
    mounted() {
        if (!this.selectedPlatforms.length) {
            this.getFeatureWisePlatform()
        }
        this.currentSectionIndex = this.sections.indexOf(this.selectedSection);
        this.nextSection = this.sections[this.currentSectionIndex+1];
        this.previousSection = this.sections[this.currentSectionIndex-1];
    },
    methods: {
        ...mapActions("DemoStore", ['setDemoLoader', 'setSelectedSection', 'setTotalPlatforms', 'setSelectedPlatforms']),
        getFeatureWisePlatform() {
            this.setDemoLoader(true)
            const url = "/api/demo/feature_platform";
            const payload = {
                feature_ids: this.selectedFeatures.map(feature => feature.feature_id)
            };

            this.$http.post(url, payload).then(res => {
                let resData = res.body.data;
                let filteredSelectedPlatforms = [];

                if (resData.length) filteredSelectedPlatforms = resData.filter(platform => platform.isSelected && platform);

                this.setTotalPlatforms(resData);
                this.setSelectedPlatforms(filteredSelectedPlatforms);
                this.setDemoLoader(false);
            }).catch(err => {
                console.log("Erron in getting platforms", err);
                this.setDemoLoader(false)
            })
        },
        downloadProductTemplate() {
            /* Sample file */
            window.location = "/static/demo/product_details.xlsx"
        },
        uploadProductTemplate(platformDetails, e) {
            this.uploadedProducts = {
                ...this.uploadedProducts,
                [platformDetails.platform_id]: e.target.files[0]
            }
        },
        saveUploadedProducts() {
            const url = "/api/demo/products";

            if (Object.keys(this.uploadedProducts).length < this.selectedPlatforms.length) {
                this.invalidCheck = true
                this.$bvToast.toast(`Please upload products for all the platforms.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
                return;
            }

            this.setDemoLoader(true);

            const payload = new FormData();
            Object.keys(this.uploadedProducts).forEach(fileName => {
                payload.append(fileName, this.uploadedProducts[fileName])
            });

            this.$http.post(url, payload).then(res => {
                this.setDemoLoader(false);
                this.$bvToast.toast(`Product(s) uploaded successfully.`, {
                    title: "Weavr Sense",
                    variant: "success",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
                this.uploadedProducts = {};
                this.setSelectedSection(this.nextSection);
            }).catch(err => {
                this.setDemoLoader(false);
                this.$bvToast.toast(`Error in uploading product(s).`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
            })
        }
    }
}
</script>

<style scoped>
.demo-input {
    padding: 4px 10px;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
    color: var(--primary_brand);
}

.demo-input::placeholder {
    color: #919191;
    font-family: "Poppins", sans-serif;
}

.demo-input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.demo-btn {
    color: #919191;
    background-color: transparent;
    border: 1px solid #EBEBEB;
    border-radius: 10px;
    padding: 6px 12px;
    margin-right: 20px;
    margin-bottom: 12px;
}

.demo-btn.active {
    color: var(--primary_brand);
    border: 1px solid var(--primary_brand);
}

.demo-btn:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #EBEBEB !important;
}

.demo-btn.active:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.section-heading h4 {
    font-size: 18px;
    font-weight: 600;
}

.section-heading p {
    color: #5E5E5E;
    font-size: 14px;
    font-weight: 500;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins", sans-serif;
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.navigationButton:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}

button.primarycolor {
    height: 35px;
    border: none !important;
    margin: 0;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

button.primarycolor:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
</style>
<style lang="scss">
table.demo-table {
    border-radius: 5px;
    border-spacing: 0;
    border-collapse: separate;
    border: 1px solid #EBEBEB !important;
    overflow: hidden;
    min-width: 900px !important;

    >thead>tr>th {
        background-color: #e7eeef !important;
        padding: 16px 32px !important;
        font-family: "Poppins", sans-serif !important;
        font-size: 14px !important;
        font-weight: 600;
    }

    >tbody>tr>td {
        font-family: "Poppins", sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        color: black !important;
    }

    // >tbody>tr>td:first-child {
    //     text-align: ;
    // }

    /* Apply a border to the right of all but the last column */
    th:not(:last-child),
    td:not(:last-child) {
        border-right: 1px solid #D5D5D5 !important;
    }

    /* Apply a border to the bottom of all but the last row */
    >thead>tr:not(:last-child)>th,
    >thead>tr:not(:last-child)>td,
    >tbody>tr:not(:last-child)>th,
    >tbody>tr:not(:last-child)>td,
    >tfoot>tr:not(:last-child)>th,
    >tfoot>tr:not(:last-child)>td,
    >tr:not(:last-child)>td,
    >tr:not(:last-child)>th,
    >thead:not(:last-child),
    >tbody:not(:last-child),
    >tfoot:not(:last-child) {
        border-bottom: 1px solid #D5D5D5 !important;
    }

    >tbody:last-child>tr>td:first-child>div:last-child {
        border-bottom: none !important;
    }
}
</style>